/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type { EnvelopedApiMenuApiMenuPublic } from '../models'
import {
  EnvelopedApiMenuApiMenuPublicFromJSON,
  EnvelopedApiMenuApiMenuPublicToJSON,
} from '../models'

/**
 *
 */
export class ApiMenuApi extends runtime.BaseAPI {
  /**
   */
  async apiMenuRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EnvelopedApiMenuApiMenuPublic>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('jwtAuth', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/api_menu/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EnvelopedApiMenuApiMenuPublicFromJSON(jsonValue),
    )
  }

  /**
   */
  async apiMenuRetrieve(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EnvelopedApiMenuApiMenuPublic> {
    const response = await this.apiMenuRetrieveRaw(initOverrides)
    return await response.value()
  }
}
